import { visit } from 'unist-util-visit';
import { selectAll } from 'hast-util-select';

var remarkRewrite = function remarkRewrite(options) {
  var _ref = options || {},
      selector = _ref.selector,
      rewrite = _ref.rewrite;

  return function (tree) {
    if (!rewrite || typeof rewrite !== 'function') return;

    if (selector && typeof selector === 'string') {
      var selected = selectAll(selector, tree);

      if (selected && selected.length > 0) {
        visit(tree, selected, function (node, index, parent) {
          rewrite(node, index, parent);
        });
      }

      return;
    }

    visit(tree, function (node, index, parent) {
      rewrite(node, index, parent);
    });
  };
};

export default remarkRewrite;